<template>


    <div class="d-none d-md-block float-right" v-if="LoopIndex === 'first'">
        <button v-on:click="move(  ItemId, 'down' )" class="btn btn-light btn-md float-left text-white option"><i class="fas fa-arrow-down"></i></button>

    </div>
    <div class="d-none d-md-block float-right" v-else-if="LoopIndex === 'last'">
        <button  v-on:click="move(  ItemId, 'up' )"  class="btn btn-light btn-md float-left text-white option"><i class="fas fa-arrow-up"></i></button>
    </div>
    <div class="d-none d-md-block float-right" v-else-if="LoopIndex === ''">
        <button  v-on:click="move(  ItemId, 'up' )"  class="btn btn-light btn-md float-left text-white option"><i  class="fas fa-arrow-up"></i></button>
        <button v-on:click="move(  ItemId, 'down' )" class="btn btn-light btn-md float-left text-white option"><i  class="fas fa-arrow-down"></i></button>
    </div>
</template>

<script>
	export default {
		props: [
		'LoopIndex', 'ItemId', 'direction'
		],

		methods: {
            move(ItemID, direction) {


                let formData = new FormData();
                formData.append('ItemId', ItemID);


                axios.post( '/manage/menu/main/'+direction+'/'+ItemID , formData )
                    .then(function(data) {
                        //@todo kijk hier naar
                        //console.log(data);



                        //
                        //
                        // if( direction = 'up'){
                        //
                        //     $('#accordion' + ItemID).attr('data-order' , parseInt(  $('#accordion' + ItemID).attr('data-order') ) - 1 )
                        //
                        //     $('#accordion' + ItemID).prev('.accordion').attr('data-order',parseInt(  $('#accordion' + ItemID).attr('data-order') ))
                        //
                        // }
                        //
                        //
                        // if( direction = 'down'){
                        //
                        //     $('#accordion' + ItemID).next('.accordion').attr('data-order', parseInt(  $('#accordion' + ItemID).attr('data-order') ))
                        //     $('#accordion' + ItemID).attr('data-order' , parseInt(  $('#accordion' + ItemID).attr('data-order') ) + 1 )
                        //
                        // }
                        //
                        //
                        //
                        // $(".acc1 .accordion").sort(sort_li).appendTo('.acc1');
                        // function sort_li(a, b) {
                        //     return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
                        // }
                        //
                        // // setTimeout(function(){
                        //
                        // $('#accordion' + ItemID).parent().find('.accordion').each(function(  index ) {
                        //
                        //     $(this).attr('data-order', index)
                        // });
                        // // },2000)
                        //
                        //
                        //

                        window.location.reload(true);
                    }.bind(this)).catch(function(data) {

                    console.log('error', data);
                    alert('f');
                });


            }
        }



	}
</script>


// WEBPACK FOOTER //
// resources/js/components/MenuButtonsMain.vue